import createReducer from 'arts/config/create_reducer';
import Constants from 'arts/config/constants';
import {
  toCamelCase
} from 'arts/config/convertCase';

const getDefaultState = () => ({
  loading: false,
  error: null,
  data: []
});

const productsList = createReducer(getDefaultState(), {
  [Constants.ProductsList.FETCH](state) {
    return {
      ...state,
      loading: true,
      data: []
    };
  },

  [Constants.ProductsList.FETCH_FAILURE](state, action) {
    return {
      ...state,
      loading: false,
      error: action.error
    };
  },

  [Constants.ProductsList.FETCH_SUCCESS](state, action) {
    return {
      ...state,
      loading: false,
      data: toCamelCase(action.data)
    };
  }
});

export default productsList;
